import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import { useArchiveUserGraphQL } from './useArchiveUserGraphQL';
import { useArchiveUserTRPC } from './useArchiveUserTRPC';

/**
 * Archive a non-SCIM org user, dual-routing between the tRPC stack and
 * the legacy Hasura/Apollo path based on the `trpc` feature flag.
 * Server-side guards are enforced on both paths (self-archive, SCIM,
 * status precondition); this hook is a thin presentation-side wrapper.
 */
export const useArchiveUser = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');
  const graphql = useArchiveUserGraphQL();
  const trpc = useArchiveUserTRPC();

  return {
    archiveUser: (userId: string) =>
      trpcEnabled ? trpc.archiveUser(userId) : graphql.archiveUser(userId),
    loading: trpcEnabled ? trpc.loading : graphql.loading,
    error: trpcEnabled ? trpc.error : graphql.error,
  };
};
